import React, { useState, useEffect } from 'react';
import axios from 'axios'
import * as $ from 'jquery';
import 'bootstrap'
import moment from 'moment';


export default function Addsearch(props) {
    const [items, setitems] = useState({ bookingdate: "", bookingdatefwd: "", bookingdateback: "" })
    const [data, setdata] = useState([])
    
    useEffect(() => {

    }, [])

    const onChangeDate = e => {
        debugger;
        const newDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
        const onefwd = moment(newDate, 'YYYY-MM-DD').add('days', 1).format('YYYY-MM-DD');
        const oneback = moment(newDate, 'YYYY-MM-DD').subtract('days', 1).format('YYYY-MM-DD');
        setitems({ ...items, bookingdate: newDate, bookingdatefwd: onefwd, bookingdateback: oneback })
        
        fetcheveintdata(newDate, onefwd, oneback)
        //const url = process.env.REACT_APP_APIURL + "Booking/bydatebooking?companyid=" + props.companyid + "&dt=" + bookingdate + "&db=" + bookingdateback + "&dn=" + bookingdatefwd;
        //fetch(url).then(res => res.json()).then(result =>

        //    setdata(result)
        //);
    };
    async function fetcheveintdata(newDatea, onefwda, onebacka) {
        debugger;
        // console.log(props.companyid)
        const url = process.env.REACT_APP_APIURL + "Booking/bydatebooking?companyid=" + props.companyid + "&dt=" + newDatea + "&db=" + onebacka + "&dn=" + onefwda;
        let Unitdata = await axios.get(url);
        await setdata(Unitdata.data);

    }
  return (
      <>
         
      <div className="row">
        <div className="col-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">By Date</h4>
            </div>
            <div className="card-body">
              {/* Date section */}
                          <div className="mb-3 col-sm-4 mx-auto">
                <div className="search-inp">
                                  <label className="form-label">Date</label>
                                 
                                  <input type="date" autoComplete="off" className="form-control" value={items.bookingdate} id="mdate" onChange={onChangeDate} required />
                </div>
              </div>
              {/* From section */}
              <div className="col-12">
                {/* farm booking */}
              <div className="shift-colors by-form-shift by_color">
                  <ul>
                      <li><span className='a_booking'></span>Available</li>
                      <li><span className='b_booking'></span>Booked</li>
                      
                  </ul>
              </div>
                              <div dangerouslySetInnerHTML={{ __html: data }} />

              </div>
            </div>
            {/* card body */}
          </div>
        </div>
      </div>
    </>
  );
}
